import React from 'react';
import { observer } from 'mobx-react-lite';

import { Step, StepStatus } from '../../../app/entities/step';
import { DropdownMenu } from '../../../components/modals/dropdown-menu/DropdownMenu';
import { useCurrentMember } from '../../../hooks/use-current-member';
import { TaskPropertyButton } from '../../tasks/components/task-property.button';

import styles from './step-status-selector.module.scss';
interface StepStatusSelectorProps {
  stepId: string;
}

export const StepStatusSelector: React.FC<StepStatusSelectorProps> = observer(({ stepId }) => {
  const step = Step.getOne(stepId)!;
  const currentMember = useCurrentMember();

  const handleChangeStatus = async (newStatus: StepStatus) => {
    try {
      await step.update({ status: newStatus });
    } catch (e) {
      console.error(e);
    }
  };

  return currentMember?.role !== 'guest' ? (
    <DropdownMenu
      items={Object.entries(Step.StatusMapper).map(([key, { title }]) => ({
        title,
        onSelect: () => handleChangeStatus(key as StepStatus),
        icon: <Dot data-status={key as StepStatus} />,
      }))}
      trigger={
        <div>
          <TaskPropertyButton
            icon={<Dot data-status={step.status} />}
            data-status={step.status}
            label={Step.StatusMapper[step.status].title}
            isActive={true}
          />
        </div>
      }
    />
  ) : (
    <TaskPropertyButton
      icon={<Dot data-status={step.status} />}
      data-status={step.status}
      label={Step.StatusMapper[step.status].title}
      isDisabled
    />
  );
});

export const Dot = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['dot']} ${className}` : styles['dot']} {...props} />
);
